import { useQuery } from '@tanstack/react-query';
import sessionStorageService from '../../../services/sessionStorage';
import rio from '../../../services/rio';

const useGetStoresNearUser = ({ ZIPCode }: { ZIPCode?: string } = {}) =>
  useQuery({
    queryKey: ['getStoresNearUser', ZIPCode],
    queryFn: async () => {
      if (!ZIPCode) {
        return {};
      }
      try {
        const response = await rio.getStoresNearZIPCode({ ZIPCode });
        sessionStorageService.setItem({
          itemName: 'storesNearUser',
          value: JSON.stringify(response),
        });
        return response;
      } catch (error) {
        throw new Error('Failed to fetch stores near user');
      }
    },
    enabled: !!ZIPCode,
    refetchOnWindowFocus: false,
  });

export default useGetStoresNearUser;
